import React from 'react';

const LoginHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      <div className="flex flex-col items-center space-y-4">
        <img
          src="/logo-icon.png"
          alt="Nurture Buddy.ai"
          className="w-20 h-20 rounded-2xl object-cover glow-primary"
        />
        <div>
          <h1 className="font-heading text-3xl font-semibold text-gradient tracking-tight">Nurture Buddy.ai</h1>
          <p className="text-sm text-muted-foreground mt-1">AI-Powered Real Estate Client Relationships</p>
        </div>
      </div>

      <div className="pt-2">
        <h2 className="font-heading text-xl font-medium text-foreground">Welcome back</h2>
        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
          Sign in to manage your clients and automated touchpoints.
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;
